import React from 'react'
import { Modal } from 'antd'
import 'antd/dist/antd.css'
import './assets/_AuthorizeConfirmHandler.scss'
import PropTypes from 'prop-types'

// eslint-disable-next-line react/prop-types
export default function ConfirmHandler ({ setModalvisible, handleAuthorizeModalOk, handleAuthorizeModalCancel }) {
  return (
    <>
    <Modal className='modal-cancel' title="提示" visible={setModalvisible} okType="text" okText="確定" cancelText="離開" maskClosable={false} onOk={handleAuthorizeModalOk} onCancel={handleAuthorizeModalCancel}>
        <p>您將使用棉花田APP會員帳號登入</p>
      </Modal>

    </>
  )
}

ConfirmHandler.propTypes = {
  setModalvisible: PropTypes.bool.isRequired,
  setHandleOk: PropTypes.func.isRequired,
  setHandleCancel: PropTypes.func.isRequired
}
